module.exports = __webpack_public_path__ + "img/clubs-intro.8438eb75.png";